jQuery(document).ready(function($) {
    function update_cart(items) {
        var result = {};
        $.ajax({
            url: '/cart/update.js',
            method: 'POST',
            dataType: 'json',
            data: {
                updates: items
            },
            async: false
        }).always(function(response) {
            result = response;
        });
        return result;
    }

    function change_cart(data) {
        var result = {};
        $.ajax({
            url: '/cart/change.js',
            method: 'POST',
            dataType: 'json',
            data: data,
            async: false
        }).always(function(response) {
            result = response;
        });
        return result;
    }

    function remove_cart(items) {
        var result = {};
        $.ajax({
            url: '/cart/update.js',
            method: 'POST',
            dataType: 'json',
            data: {
                updates: items
            },
            async: false
        }).always(function(response) {
            result = response;
        });
        return result;
    }

    function get_cart() {
        var result = {};
        $.ajax({
            url: '/cart.js',
            dataType: 'json',
            async: false
        }).always(function(response) {
            result = response;
        });
        return result;
    }

    function add_cart(id, quantity) {
        var result = {};
        $.ajax({
            url: '/cart/add.js',
            method: 'POST',
            dataType: 'json',
            data: {
                id: id,
                quantity: quantity,
            },
            async: false
        }).done(function(response){
            result = response;
        }).fail(function(response){
            result = response;
        }).always(function(response) {
            result = response;
        });
        return result;
    }

    function update_cart_html(items) {
        var list = '';
        var cart_header = '';console.log(items);
        if (items.items.length > 0){
            $('.cart-menu>a').find('span').html(items.item_count);
            $('.badge-line').html(items.item_count);
        }else{
            $('.cart-menu').find('span').html('0');
            $('.badge-line').html(0);
        }
        if (items.item_count > 0) {
            for (var i in items.items) {
                list += '<div class="shop-item clearfix">' +
                    '<a class="left image-link" href="' + items.items[i].url + '">' +
                    '<img  src="' + items.items[i].image + '"  alt="' + items.items[i].title + '"> ' +
                    '</a> ' +
                    '<div class="left line-info"> ' +
                    '<a href="' + items.items[i].url + '" class="product-title">' + items.items[i].title + '</a> ' +
                    '<span class="amount money">' + items.items[i].quantity + ' ✕ ' +money_format+(items.items[i].price/100)+'</span> ' +
                    '<a class="remove-product" href="/cart/change?line=' + (parseInt(i) + 1) + '&amp;quantity=0" title="Remove this item"> ' +
                    '<i class="fa fa-trash"></i> ' +
                    '</a>' +
                    '</div> ' +
                    '</div>';
                    cart_header +='<li class="clear-all"> ' +
                    '<div class="cart-item clear-all"> ' +
                    '<img src="' + items.items[i].image + '" alt="' + items.items[i].title + '"> ' +
                    '<div class="name"> ' +
                    '<a href="' + items.items[i].url + '">' + items.items[i].title + '</a> ' +
                    '<span>'+items.items[i].quantity+' ✕ ' +money_format+(items.items[i].price/100)+'</span> ' +
                    '</div> ' +
                    '<a href="/cart/change?line=' + (parseInt(i) + 1) + '&amp;quantity=0" class="remove-product" title="Remove this item">x</a> ' +
                    '</div> ' +
                    '</li>';
            }
            $('.total-price').html('<span class="money">'+money_format+(items.total_price/100)+'</span>');
            $('.footer-cart .header-cart-total').html(money_format+(items.total_price/100));
            $('.mini-cart-container .footer-cart').show();
        }else{
            $('.total-price').html('0');
            $('.mini-cart-container .footer-cart').hide();
            list +="<div class='shop-item'>No product in your cart!</div>";
            cart_header +='<li class="clear-all">No product in your cart!</li> ';
        }
        $('.mini-cart-container ul').html(cart_header);
        $('.aside-list-product').html(list);
    }
    function add_cart_notice(item){
        $('.product-add').html('"'+item.product_title+'"');
        $('.sidebar-overlay').addClass('active');
        $('.aside-shop').addClass('active');
    }
    $(document).on('click', '.add-to-cart', function(e) {
        e.preventDefault();
        var $this = $(this);
        var product = $this.parents('.content-product');
        product.addClass('active');
        product.find('.action li').hide();
        product.find('.action li.view-cart').css('display','inline-block');
        var variant = $(this).data('variant');
        setTimeout(function(){
            if (variant > 0) {
                var item = add_cart(variant, 1);
                if (typeof item.id !== 'undefined') {
                    var items = get_cart();
                    console.log(item);
                    if (typeof items.token !== 'undefined') {
                        update_cart_html(items);
                        add_cart_notice(item,$this);
                        product.find('.action li.view-cart').attr({'data-balloon':'View cart','data-balloon-pos':'up'})
                        product.find('.action li.view-cart .fa').removeClass('fa-spin fa-refresh').addClass('fa-check');
                    }
                }else{
                    alert(JSON.parse(item.responseText).description);
                    product.removeClass('active');
                    product.find('.action li').css('display','inline-block');
                    product.find('.action li.view-cart').hide();
                }
            }else{
                console.log(variant.length);
            }
        },1500);
    });
    $(document).on('click', '.quick-add-to-cart', function(e) {
        e.preventDefault();
        var data = $(this).parents('.quick-form-product').serializeArray();
        var quantity = data[0].value;
        var variant = data[1].value;
        console.log(data);
        if (variant > 0) {
            var item = add_cart(variant, quantity);
            if (typeof item.id !== 'undefined') {
                var items = get_cart();
                console.log(items);
                if (typeof items.token !== 'undefined') {
                    update_cart_html(items);
                    add_cart_notice();
                }
            }else{
                alert(JSON.parse(item.responseText).description);
            }
        }else{
            console.log(variant.length);
        }
    });
    $(document).on('click', '.single-product-add', function(e) {
        e.preventDefault();
        var $this = $(this);
        var number = $this.data('max');
        var title = $this.data('title');
        var form = $(this).closest('form');
        var variant_id = form.find('input[name="id"]').val();
        var quantity = 1;
        if (form.find('input[name="quantity"]').length > 0) quantity = form.find('input[name="quantity"]').val();
        if (quantity <= number) {
            $this.html('<i class="fa fa-refresh fa-spin"></i>');
            setTimeout(function () {
                if (variant_id.length > 0) {
                    var item = add_cart(variant_id, quantity);
                    if (typeof item.id !== 'undefined') {
                        var items = get_cart();
                        if (typeof items.token !== 'undefined') {
                            update_cart_html(items);
                            $this.html('<i class="fa fa-check"></i>').wrap('<a href="/cart" data-balloon="View cart" data-balloon-pos="up" style="color: #fff;display: inline-block"></a>');
                            add_cart_notice(item);
                        }
                    } else {
                        $this.html('Sold Out!');
                    }
                }
            }, 1500);
        }else{
            $('#modal-alert').find('.modal-body').html('Only ' + number + ' product "'+title+'" left!');
            $('#modal-alert').modal('show');
            //alert('Only ' + number + ' products left!');
        }
    });
    $(document).on('click', '.remove-product', function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var href_array = href.split('?');
        var search = href_array[1];
        var search_arr = search.split("&");
        var data = {};
        for (var i in search_arr) {
            var item = search_arr[i].split('=');
            data[item[0]] = item[1];
        }
        var items = change_cart(data);
        if (typeof items.token !== 'undefined') {
            update_cart_html(items);
        }
    });
});